/* Built in Imports */
import NextLink from 'next/link';
/* External Imports */
import { Box, Flex, Heading, Link, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
/* Internal Imports */
import StructuredTextParser from '@msr/Utility/StructuredTextParser';
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
import SimpleButton from '@msr/components/Buttons/SimpleButton';
import { useMediaQuery } from 'react-responsive';
/* Styles */
/* Services */
/**
 * Renders ThevaramIntroSection Component
 * @param {Object} sectionContent - dato
 * @param {string} region - region of the page
 * @param {string} lang - Language of the page
 * @returns {ReactElement} ThevaramIntroSection Component
 */

export const TwoColumnImageAndText = ({ sectionContent, region, lang }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  if (!isMobile) {
    return (
      <>
        <Box
          m={{ base: '10px', md: '40px', lg: '0 auto' }}
          height="auto"
          pb="20px"
          backgroundColor={'#873102'}
          display="flex"
          flexDir="column"
        >
          <Box
            height="auto"
            m="0 auto"
            py={'50px'}
            display="grid"
            placeItems="center"
            maxW={'1008px'}
          >
            <Flex
              flexDir={{ base: 'column', md: 'column', lg: 'row' }}
              alignItems="start"
              m={{ base: '0 20px', md: '0 20px', lg: '0' }}
            >
              <Box
                pt={{ base: '30.01px', md: '63px', lg: '20px' }}
                width={{ base: '100%', md: '100%', lg: '500px', xl: '500px' }}
                position="relative"
                zIndex="1"
              >
                <LazyLoadImageComponent src={sectionContent[0]?.image?.url} />
                <Box
                  w={{base:'80.2%', md:'70.3%'}}
                  h={{ base: 15, sm: 20, lg: '30.4px' }}
                  objectFit="contain"
                  transform="rotate(-178.76deg)"
                  position="absolute"
                  left="25.65px"
                  background={'#FF8B04'}
                  outline="1px solid transparent"
                  zIndex="-1"
                  bottom={{ base: '-5px', sm: '-5px', md: '-10px' }}
                />
              </Box>
              <Box
                as="article"
                mt={{ base: '24px', md: '0' }}
                mr={{ base: '0', md: '0', lg: '54px' }}
                width={'450px'}
              >
                <Heading
                  as="h2"
                  fontStyle="normal"
                  fontWeight="600"
                  fontSize={{ base: '24px', sm: '24px', lg: '32px' }}
                  lineHeight={{ base: '33.36px', sm: '33.36px', lg: '45.28px' }}
                  color="#EFE0CB"
                  fontFamily={
                    lang === 'ta' ? 'MuktaMalar' : 'FedraSerifAStdBook'
                  }
                  mt={'20px'}
                >
                  {sectionContent[1].text}
                </Heading>
                <Text as="p" mb="20px" className="left-intro-section-img">
                  <style>
                    {`
                .left-intro-section-img{
                  p {
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 27.2px;
                    color: #FFF7E9
                  }
                }
                `}
                  </style>
                  <Box w={{ md: '390px' }}>
                    <StructuredTextParser
                      str={render(sectionContent[2].body)}
                      p="0"
                      lang={lang}
                      color={'#FFF7E9'}
                      fontSize={'16px'}
                      pageName="tamilthembu"
                      fontFamily={
                        lang === 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'
                      }
                    />
                  </Box>
                </Text>
                <Box>
                  <Flex
                    flexDir={{ md: 'row', base: 'column' }}
                    alignItems={{ base: 'start', md: 'center' }}
                  >
                    <SimpleButton
                      style={sectionContent[3]}
                      region={region}
                      lang={lang}
                      mb="0"
                      mt="0"
                      fontSize="16px"
                      width="151px"
                      lineHeight="20px"
                      margin="0"
                    />
                  </Flex>
                </Box>
              </Box>
            </Flex>
          </Box>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box
          m={{ base: '0', md: '40px', lg: '0 auto' }}
          height="auto"
          pb="20px"
          backgroundColor={'#873102'}
          display="flex"
          flexDir="column"
        >
          <Box
            height="auto"
            m="0 auto"
            py={'25px'}
            display="grid"
            placeItems="start"
            maxW={'1008px'}
          >
            <Flex
              flexDir={{ base: 'column', md: 'column', lg: 'row' }}
              alignItems="center"
              m={{ base: '0 20px', md: '0 20px', lg: '0' }}
            >
              <Box
                as="article"
                mt={{ base: '24px', md: '0' }}
                mr={{ base: '0', md: '0', lg: '54px' }}
              >
                <Heading
                  as="h2"
                  fontStyle="normal"
                  fontWeight={'600'}
                  fontSize={{ base: '24px', sm: '24px', lg: '32px' }}
                  lineHeight={{ base: '33.36px', sm: '33.36px', lg: '45.28px' }}
                  color="#EFE0CB"
                  fontFamily={
                    lang === 'ta' ? 'MuktaMalar' : 'FedraSerifAStdBook'
                  }
                  textAlign={'center'}
                  m="0 auto"
                  w={{ base: '80%', md: '100%' }}
                >
                  {sectionContent[1].text}
                </Heading>

                <Box
                  pt={{ base: '30.01px', md: '63px', lg: '20px' }}
                  width={{ base: '100%', md: '100%', lg: '500px', xl: '500px' }}
                  position="relative"
                  zIndex="1"
                >
                  <LazyLoadImageComponent src={sectionContent[0]?.image?.url} />
                  <Box
                    w={{base:'80.2%', md:'70.3%'}}
                    h={{ base: 15, sm: 20, lg: '30.4px' }}
                    objectFit="contain"
                    transform="rotate(-178.76deg)"
                    position="absolute"
                    left="25.65px"
                    background={'#FF8B04'}
                    outline="1px solid transparent"
                    zIndex="-1"
                    bottom={{ base: '-5px', sm: '-5px', md: '-10px' }}
                  />
                </Box>
                <Text
                  as="p"
                  w={{ base: '100%', md: '' }}
                  m={{ base: '50px auto 20px auto', md: '0 0 20px 0' }}
                  className="left-intro-section_1"
                  lineHeight={'19.2px'}
                >
                  <style>
                    {`
                .left-intro-section_1{
                  p {
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 27.2px;
                    color: #FFF7E9;
                    text-align: center;
                  }
                }
                `}
                  </style>
                  <StructuredTextParser
                    str={render(sectionContent[2].body)}
                    p="0"
                    lang={lang}
                    color={'#FFF7E9'}
                    fontSize={'16px'}
                    pageName="tamilthembu"
                    className="visual_text"
                    fontFamily={
                      lang === 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'
                    }
                  />
                </Text>
                <Box>
                  <Flex
                    flexDir={{ md: 'row', base: 'column' }}
                    alignItems={{ base: 'center', md: 'center' }}
                  >
                    <SimpleButton
                      style={sectionContent[3]}
                      region={region}
                      lang={lang}
                      mb="0"
                      mt="0"
                      fontSize="16px"
                      width="209px"
                      lineHeight="20px"
                      margin="0"
                    />
                  </Flex>
                </Box>
              </Box>
            </Flex>
          </Box>
        </Box>
      </>
    );
  }
};

export default TwoColumnImageAndText;
